import { GetterTree } from 'vuex';
import { LinkToPayState } from './types';
import { RootState } from '../../types';
import { isPaymentExpired } from '@/common/utils';

export const getters: GetterTree<LinkToPayState, RootState> = {
  getState(state): LinkToPayState {
    return state;
  },
  isPaymentExpired (state) {
    if (!state.payment) return false
    return isPaymentExpired(state.payment)
  }
};